<template>
  <div>
    <b-modal
      :id="'bv-modal-combo'"
      class="z-index"
      title="Создать комбо из дистанций"
      hide-footer
      @hidden="resetModal"
    >
      <div class="distance_wrapper distance_name">
        <label
          for="comboName"
          class="distance_label"
        >Название комбо</label>
        <b-form-input
          id="comboName"
          v-model="comboName"
          placeholder="Название комбо"
          label="Название комбо"
          vs-placeholder="Название комбо"
          class="w-full"
        />
      </div>

      <div
        id="combo-multi-registration"
        class="distance_wrapper distance_combo__wrapper"
      >
        <b-form-checkbox
          id="checkCombo"
          v-model="combo_is_multi_registration"
          checked="false"
          class="custom-control-primary"
          name="check-view"
          switch
        />
        <label
          class="distance_combo__label"
          for="checkCombo"
        >Отключить проверку дублей?</label>
        <b-tooltip target="combo-multi-registration">
          Отключение дубликатов не будет влиять на комбо, в которых есть
          эстафеты
        </b-tooltip>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.combo
          class="distance_form__button"
          @click="toggleCollapsed('combo')"
        >
          Выбери дистанции
          <span>{{ collapsedStates.combo ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="combo">
          <b-form-checkbox-group
            v-for="(distance, index) in distances"
            :key="index"
            v-model="selectedDistances"
          >
            <b-form-checkbox
              :key="index"
              class="mt-1 mr-1"
              :value="distance"
            >
              {{ distance.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-collapse>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.discountCombo
          class="distance_form__button"
          :class="{ distance_form__combo: collapsedStates.discountCombo }"
          @click="toggleCollapsed('discountCombo')"
        >
          Выбери скидку
          <span>{{ collapsedStates.discountCombo ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="discountCombo">
          <discount-switcher
            :discount-is-percent="combo_discount_is_percent"
            :value="+combo_discount_value"
            @discountType="value => (combo_discount_is_percent = value)"
            @input="value => (combo_discount_value = value)"
          />
        </b-collapse>
      </div>
      <span
        id="save-button"
        class="d-inline-block button-container"
      >
        <b-button
          id="tooltip-target-1"
          type="submit"
          variant="primary"
          class="combo-button"
          :disabled="selectedDistances.length < 2"
          @click="addComboDistances"
        >
          Создать
        </b-button>
      </span>
      <b-tooltip
        v-if="selectedDistances.length < 2"
        target="save-button"
      >
        Комбо должно содержать минимум 2 дистанции
      </b-tooltip>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormCheckbox,
  BButton,
  BModal,
  BFormCheckboxGroup,
  BTooltip,
  BCollapse,
  VBToggle,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import DiscountSwitcher from '@/global-components/DiscountSwitcher.vue'

export default {
  name: 'DistanceModalCombo',
  components: {
    BFormInput,
    BFormCheckbox,
    BButton,
    BModal,
    BFormCheckboxGroup,
    BTooltip,
    BCollapse,
    DiscountSwitcher,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: ['select_kinds_sport'],
  data() {
    return {
      selectedDistances: [],
      sale: null,
      comboName: null,
      prices: [],
      combo_discount_is_percent: false,
      combo_discount_value: null,
      combo_is_multi_registration: false,
      collapsedStates: {
        combo: false,
        discountCombo: false,
      },
    }
  },
  computed: {
    distances() {
      return this.select_kinds_sport.filter(item => !item.related_distances)
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    addComboDistances() {
      const uuid = uuidv4()
      this.select_kinds_sport.push({
        name: this.comboName,
        type: 'combo',
        combo_discount_is_percent: this.combo_discount_is_percent,
        combo_discount_value: this.combo_discount_value,
        related_distances: this.selectedDistances.map(e => e.uuid),
        is_multi_registration: this.combo_is_multi_registration,
        uuid,
      })
      this.resetModal()
      this.$bvModal.hide('bv-modal-combo')
    },
    addPrices() {
      this.prices.push({
        c_to: '',
        c_from: '',
        value: '',
      })
    },
    resetModal() {
      this.combo_discount_is_percent = false
      this.combo_discount_value = null
      this.selectedDistances = []
      this.combo_is_multi_registration = false
      this.collapsedStates = {
        combo: false,
        discountCombo: false,
      }
    },
    toggleCollapsed(collapseId) {
      this.collapsedStates[collapseId] = !this.collapsedStates[collapseId]
    },
  },
}
</script>

<style lang="scss" scoped>
.button-container {
  float: right;
}

.distance_wrapper {
  background-color: #f8f8f8;
  border-radius: 10px;

  padding: 10px;

  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.distance_name {
  &__input {
    margin-top: 0.5rem;
  }
}

.distance_combo__label {
  font-size: 14px;
  margin-bottom: 0;
}

.distance_label {
  display: block;
  font-size: 0.75rem;
}

.distance_combo__wrapper {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.distance_form__combo {
  margin-bottom: 1rem;
}
</style>
